import randomElement from "../utility/randomElement";
import selectV3 from "./selectV3";

function selectUsualTask(config, state, history){

    let allMinigamesName = config.minigames.map(mg => mg.name);
    let clearHistory = dropService(history);
    let length = clearHistory.length;
    let result;
    if(config.type === "menu"){
        return randomElement(dropFinished(allMinigamesName, clearHistory));
    }
    if(config.type === "subtask"){
        if(randomElement(dropFinished(allMinigamesName, clearHistory))){
            return config.minigames[0];
        }
        else{ 
            return undefined;
        }
    }
    
    switch (state.objects.mode){
        case 0:{
            if(length === 0 || clearHistory[length-1].finished || config.type === "menu"){
                result = randomElement(dropFinished(allMinigamesName, clearHistory));
            }
            else{
                result = clearHistory[length-1].minigame.name;
            }
            break;
        }
        case 1:{
            if(length === 0 || clearHistory[length-1].finished || config.type === "menu"){
                result = dropFinished(allMinigamesName, clearHistory)[0];
            }
            else{
                result = clearHistory[length-1].minigame.name;
            }
            break;
        }
        case 2:{
            result = selectV3(config, state, clearHistory);
            break;
        }
    }
    return result;
}

function finishedMinigames(history) {
	return history.filter(({ finished }) => finished).map(({ minigame: { name } }) => name);
}
function dropFinished(tasks, history) {
	const finished = finishedMinigames(history);
	return tasks.filter(name => !finished.includes(name));
}

function dropService(history){
    return history.filter(hr => hr.minigame.minigameType !== "Intro" && hr.minigame.minigameType !== "Greeting" && hr.minigame.minigameType !== "Final");
}

export default selectUsualTask